'use strict';

const Analytics = require('./analytics');

class AnalyticsDigitalWallet extends Analytics {
    init (globalContainer, helperContainer) {
        this.logName = 'AnalyticsDigitalWallet';
        super.init(globalContainer, helperContainer);

        this.prepareErrorObservers();
        this.prepareTopUpObservers();
        this.prepareTopUpFromGiftcardCheckBalanceObservers();
        this.prepareCheckoutObservers();
    }

    prepareErrorObservers () {
        var _self = this;

        $('body').on('customer:digital_wallet_topup_error', function (e, data) {
            _self.quickImpressionSender.pushTopUpError(data.step, data.errorCode);
        });
    }

    prepareTopUpObservers () {
        var _self = this;
        $('body').on('digitalWallet:topup_credit', function (e) {
            _self.quickImpressionSender.pushCreditTopUp();
        });

        $('body').on('digitalWallet:topup_giftcard', function (e, data) {
            _self.quickImpressionSender.pushGiftcardTopUp(data.step, data.cardModel, data.success);
        });

        $('body').on('digitalWallet:topup_exit', function (e, data) {
            _self.quickImpressionSender.pushExitTopUpFlow(data.step, data.action, data.success);
        });
    }

    prepareTopUpFromGiftcardCheckBalanceObservers () {
        var _self = this;
        $('body').on('giftcard:topup_giftcard', function (e, data) {
            _self.quickImpressionSender.pushGiftcardTopUpFromCheckBalance(data.action);
        });
    }

    prepareCheckoutObservers () {
        var _self = this;
        $('body').on('checkout:remove_digital_wallet', function (e) {
            _self.quickImpressionSender.pushRemoveDigitalWallet();
        });
    }
}
const obj = new AnalyticsDigitalWallet();
module.exports = obj;
